<template>
  <BLayoutExpansionTable
    :value="list"
    :readonly="readonly"
    :skeleton="skeleton"
    :validate="validate"
    :pagination="pagination"
    type-table="roadmap-directions"
    :sortable-positions="!readonly"

    :title="title"
    :creatable="creatable"
    :button-text="buttonText"

    v-on="$listeners || {}"
  />
</template>

<script>
import BLayoutExpansionTable from '@/components/layouts/BLayoutExpansionTable.vue'


export default {
  name: 'BExpansionTableDirections',
  components: {
    BLayoutExpansionTable,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    readonly: Boolean,
    skeleton: Boolean,
    pagination: Object,
    validate: [String, Object],

    title: {
      type: String,
      required: true,
    },
    creatable: Boolean,
    buttonText: String,
  },
}
</script>
